import { useParams } from "react-router-dom";
import Hero from "../../components/Hero";
import OfferContentPage from "../../features/web/coursesAndOffers/OfferContentPage";
import { useOffers } from "../../features/web/coursesAndOffers/hooks/useOffers";
import MetaTags from "../../components/MetaTags";

function OfferContent() {
    const { grade } = useParams();
    let year;
    if (grade === "1") {
        year = "الصف الأول الثانوي";
    }
    if (grade === "2") {
        year = "الصف الثاني الثانوي";
    }
    if (grade === "3") {
        year = "الصف الثالث الثانوي";
    }

    const { offerId } = useParams();

    const filter = { field: "id", value: offerId };
    const includeFields = ["lectures", "lecturesCount", "lecturesExists"];

    const { isPending, offers } = useOffers({
        filter,
        includeFields,
    });

    if (isPending) return;

    const offer = offers?.data[0];
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | محتويات العرض"
                description="صفحة محتويات العرض على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض محتويات العرض لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <Hero
                title="مادة اللغة العربية"
                description={year}
                pagesLinks={[
                    {
                        name: `${offer.attributes.name}`,
                        link: `/${grade}/offers/${offer.id}`,
                    },
                    { name: "الصفحة الرئيسية", link: "/" },
                    { name: `${year}`, link: `/${grade}/courses` },
                    { name: `العروض`, link: `/${grade}/offers` },
                ]}
            />

            <OfferContentPage offer={offer} isPending={isPending} />
        </>
    );
}

export default OfferContent;
